import React, { useEffect, useState } from 'react';
import InfoModal from '../../../../modals/info-modal/info-modal';
import LogoMulticolor from '../../../../assets/images/logo/logo-multicolor.svg';
import {
    Navbar,
    NavbarTitle,
    TopbarLogo,
} from './topbar.styles';
import { useLocation } from 'react-router-dom';
import useCustomNavigate from '../../../../hooks/useCustomNavigate';
import ProgressSteps from '../progress-bar/progress-bar';
import CTAButton from '../../../../components/cta-button/cta-button';
import useContactUsModalStore from '../../../../stores/contactUsModalStore';
import useIsMobile from '../../../../hooks/useIsMobile';
import MaterialIcon from '../../../../components/material-icon';
import { colorPalette } from '../../../../utils/theme';

interface TopbarProps {
    currentStep: number;
    stripeEligible?: boolean;
}

const Topbar: React.FC<TopbarProps> = ({ currentStep, stripeEligible = true }) => {
    const navigate = useCustomNavigate();
    const location = useLocation();
    const isMobile = useIsMobile();

    // Stores
    const setIsContactUsVisible = useContactUsModalStore(state => state.setIsVisible);

    // States
    const [isHistoryAvailable, setIsHistoryAvailable] = useState(false);
    const [isInfoModalVisible, setIsInfoModalVisible] = useState<boolean>(false);

    // Set Title
    useEffect(() => {
        const historyState = window.history.state;
        setIsHistoryAvailable(historyState && historyState.idx > 0);
    }, [location]);

    return (
        <>
            <Navbar className="navbar navbar-expand-lg navbar-dark" themeVariant="light">
                <div className="container-fluid d-flex justify-content-between">
                    <div className="d-flex align-items-center" style={{ gap: 8, cursor: "pointer" }}>
                        <TopbarLogo src={LogoMulticolor} alt="Logo" onClick={() => navigate("/", { replace: true, clearHistory: true })} />
                        <NavbarTitle className="ms-2">{isMobile ? "Onboarding" : "New Tenant Onboarding"}</NavbarTitle>
                    </div>

                    <div className="d-flex align-items-center">
                        {isMobile ? (
                            <MaterialIcon icon="call" size={24} color={colorPalette.blue500} onClick={() => setIsContactUsVisible(true)} />
                        ) : (
                            <CTAButton
                                variant="ghost"
                                size="S"
                                label="Questions? Contact us"
                                onClick={() => setIsContactUsVisible(true)}
                                noPadding
                            />
                        )}
                    </div>
                </div>
                {isInfoModalVisible && (
                    <InfoModal onClose={() => setIsInfoModalVisible(false)} />
                )}
            </Navbar>

            {/* ProgressBar */}
            <ProgressSteps currentStep={currentStep} stripeEligible={stripeEligible} />
        </>
    );
};

export default Topbar;
